"use strict";
exports.__esModule = true;
exports.TypeSelectFacet = exports.TypeCheckboxFacet = void 0;
var decorators_1 = require("./../decorators");
var logic_1 = require("./../logic");
exports.TypeCheckboxFacet = decorators_1.decorateCheckboxFacet(logic_1.TypeFacet);
exports.TypeSelectFacet = decorators_1.decorateSelectFacet(logic_1.TypeFacet);
//# sourceMappingURL=TypeFacets.js.map